<template>
  <div>

    <v-select
      :items="servicesList"
      v-model="mutableSelectedServices"
      label="Add on items select"
      item-value="id"
      item-text="name"
      return-object
      multiple
      attach
      clearable
      hide-selected
    >
      <template slot="item" slot-scope="props">
        Product: {{ props.item.name }} | Category: {{ props.item.category.name }}
      </template>
      <template slot="selection" slot-scope="props">
        <span class="v-chip v-chip--select-multi theme--light">
          <span class="v-chip__content">
            {{ props.item.name }}
          </span>
        </span>
      </template>
    </v-select>
    <v-data-table
      :items="mutableSelectedServices"
      :headers="productsTableHeaders"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-layout justify-space-between align-center>
            <v-select
              v-if="upgrade_id === props.item.id"
              :items="getProductsByCategoryId(props.item.categories_id)"
              v-model="change_product_from_category_model"
              @change="changeProductFromCategory(props.item)"
              label="Select Another Product from same category"
            ></v-select>
            <span v-if="upgrade_id !== props.item.id">
                    {{ props.item.name }}
                  </span>
            <v-btn v-if="upgrade_id !== props.item.id"
                   small
                   align-rigth
                   @click="upgrade_id = props.item.id"
            >Upgrade</v-btn>
          </v-layout>
        </td>
        <td class="quantity_bgcolor">
          <v-edit-dialog
            :return-value.sync="props.item.amount"
            large
            lazy
            persistent
          >
            <div>{{ props.item.amount }}</div>
            <template v-slot:input>
              <div class="mt-3 title">Update Amount</div>
            </template>
            <template v-slot:input>
              <v-text-field
                v-model="props.item.amount"
                label="Quantity"
                single-line
                autofocus
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </td>
        <td>${{ props.item.price }}</td>
        <td>${{ props.item.amount * props.item.price }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="footer">
        <v-flex v-if="discount">
          <v-text-field label="Remarks in $" type="number" v-model="discountValue"></v-text-field>
        </v-flex>
        <v-flex tag="h3" v-if="price">
          Final price: ${{ finalPrice }}
        </v-flex>
      </template>
    </v-data-table>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'ServicesDataTable',
    props: {
      selectedServices: {
        type: Array
      },
      discount: {
        type: Boolean,
        default: false
      },
      price: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        servicesList: 'allProducts',
        serviceById: 'getProductById',
        getProductsByCategoryId: 'getProductsByCategoryId'
      }),
      finalPrice () {
        return this.mutableSelectedServices.reduce((total, service) => total + (service.price * service.amount), 0) +
          (this.discount ? this.discountValue : 0)
      }
    },
    data () {
      return {
        discountValue: 0,

        upgrade_id: false,
        change_product_from_category_model: null,

        mutableSelectedServices: this.selectedServices,

        productsTableHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Qty', value: 'amount', width: '5px' },
          { text: 'Unit', value: 'price' },
          { text: 'Subtotal', value: 'price' },
          { text: 'Actions', value: 'name', sortable: false }
        ]
      }
    },
    watch: {
      mutableSelectedServices (services) {
        if (!services.length) return
        this.$emit('services:changed', _.map(services, (s) => {
          return {
            name: s.name || s.description,
            id: s.id,
            amount: s.amount,
            price: s.price
          }
        }))
      }
    },
    methods: {
      deleteItem (item) {
        const index = this.mutableSelectedServices.indexOf(item)
        this.mutableSelectedServices.splice(index, 1)
      },
      changeProductFromCategory (oldItem) {
        if (oldItem.id !== this.change_product_from_category_model) {
          this.mutableSelectedServices = _.unionBy([this.serviceById(this.change_product_from_category_model)], this.mutableSelectedServices, 'id')
          this.deleteItem(oldItem)
        }
        this.change_product_from_category_model = null
        this.upgrade_id = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ServicesDataTable.vue?75c59a18